module.exports = ".progressButton {\n  width: 100%; }\n\n.cityformWrapper {\n  width: 100%; }\n"